import { Component } from '@angular/core';
import { ConfigService } from '@ng-darwin/config';

/**
 * @description AgEntitiesRootComponent
 * @class AgEntitiesRootComponent
 */
@Component({
  standalone: false,
  selector: 'app-ag-entities-root',
  templateUrl: './ag-entities-root.component.html',
})
export class AgEntitiesRootComponent {
  public isSoftCustomer = false;
  /**
   *
   * @param _configService ConfigService
   */
  constructor(private readonly _configService: ConfigService) {
    this.isSoftCustomer =
      sessionStorage.getItem('app-unique-id') ===
      this._configService.config.app['cdncApplication'];

  
  }
}
